import React, { useState, useEffect, useMemo } from 'react';
import base64 from 'base-64';
import { useDispatch, useSelector } from 'react-redux';
import { getAggrRequest } from 'redux-api/action/aggr';
import Map from './map';

function MapChart({
  term,
  dateTo,
  dateFrom,
  dataType,
  dateRange,
  filters,
  terms,
  reloadChecked,
  isAdmin,
}) {
  const [queriedKey, setQueriedKey] = useState(null);
  const dispatch = useDispatch();

  const { currency } = useSelector((state) => state.config);
  const { analytics_type } = useSelector((state) => state.profile.payload);

  const query = useMemo(() => {
    if (!dataType || !dateTo || !dateFrom || !term) return null;

    let queryString = `currency=${currency}&term=${term}&dateTo=${dateTo}&dateFrom=${dateFrom}&dateRange=${dateRange}&dataType=${dataType}&size=500&version=7&enterprise=${
      analytics_type || 'standard'
    }&isAdmin=${isAdmin}`;

    if (filters) {
      queryString = `${queryString}&filters=${filters}`;
    }

    if (terms) {
      queryString = `${queryString}&terms=${terms}`;
    }

    return queryString;
  }, [
    dateTo,
    dateFrom,
    dateRange,
    dataType,
    term,
    filters,
    terms,
    currency,
    analytics_type,
    isAdmin,
  ]);

  useEffect(() => {
    if (!query) return;

    const key = base64.encode(query);

    setQueriedKey(key);
    dispatch(getAggrRequest({ key, query, currency, isAdmin }));
  }, [dispatch, query, currency, reloadChecked, isAdmin]);

  return <Map id={queriedKey} height={748} />;
}

export default MapChart;
